import type { ThemeMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'

import { CloseIcon, Box as DarkBox, IconButton } from '@hivewatch/dark'

interface MapPanelHeaderIProps {
  mode: ThemeMode
  onClose: () => void
}

export const MapPanelHeader = ({ mode, onClose }: MapPanelHeaderIProps) => {
  const { t } = useTranslation()
  const prefix = mode === 'light' ? 'light.' : ''
  return (
    <DarkBox
      alignItems='center'
      display='flex'
      gap='12px'
      height='64px'
      justifyContent='space-between'
      pb='16px'
      pt='16px'
      px='24px'
    >
      <DarkBox
        as='span'
        color={`${prefix}text.primary`}
        fontFamily="'Soehne Kraftig', 'Söhne Kräftig', sans-serif"
        fontSize='20px'
        fontWeight='500'
        lineHeight='28px'
        whiteSpace='nowrap'
      >
        {t('incidents:drawer_map_panel')}
      </DarkBox>
      <IconButton
        _active={{ bg: 'transparent' }}
        aria-label='close map panel drawer'
        colorScheme={mode}
        dimension={36}
        hoverBgColor='transparent'
        icon={<CloseIcon size={11} />}
        onClick={onClose}
      />
    </DarkBox>
  )
}
